module.exports = __webpack_public_path__ + "img/order-detail-content-bg-hen.a4955fa2.png";